<div class="card m-3">
  <div class="card-header d-flex justify-content-between align-items-baseline">
    <h3 class="card-title">
      Client - Liste
      <small *ngIf="loading">Lädt...</small>
    </h3>

    <a [routerLink]="['/clients/neu']" class="btn btn-success">
      <i class="fa fa-plus"></i> Neuen Client anlegen
    </a>
  </div>
  <table *ngIf="entities.length > 0" class="table table-striped">
    <thead>
      <tr>
        <th>
          ID
        </th>
        <th>
          Name
        </th>
        <th>
          Beschreibung
        </th>
        <th class="right-align">Aktionen</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let client of entities">
        <td>
          {{ client.id }}
        </td>
        <td>
          <a [routerLink]="['/clients', client.id]">
            {{ client.name }}
          </a>
        </td>
        <td>
          {{ client.description }}
        </td>
        <td class="right-align">
          <a (click)="onDelete($event, client)" href="#" class="btn btn-danger btn-sm" title="Löschen">
            <i class="fa fa-trash-o"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="card-body" *ngIf="!loading && entities.length === 0">
    <div class="alert alert-info">
      Es wurden keine Einträge gefunden.
    </div>
  </div>

  <div *ngIf="entities.length" class="card-footer">
    <div class="d-flex flex-row justify-content-end">
      <p-paginator currentPageReportTemplate="Zeige Einträge {first} bis {last} von {totalRecords}."
        [showCurrentPageReport]="true" [rows]="size" [rowsPerPageOptions]="[10,20,50,100,200,{showAll:'Alle'}]"
        [totalRecords]="totalsize" (onPageChange)="handlePageChange($event)"></p-paginator>
    </div>
  </div>
</div>
